import 'swiper/css'
import 'swiper/css/pagination'
import jQuery from 'jquery'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Container, Img, Span, DesktopGrid } from './styles'
import { useNavigate } from 'react-router-dom'
import { Pagination } from 'swiper/modules'
import useMediaQuery from '@mui/material/useMediaQuery'
import notify from 'components/UI/toast'
import { trackClick } from '../../utils/gtm'
import { tagIdFromLegacySuffix } from '../../utils/marketplaceTagIds'
import { useScreenTracking } from '../../hooks/useScreenTracking'

export default function FeaturedBrands ({ brandsData }) {
  const [brands, setBrands] = useState([])
  const [Loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const screenName = useScreenTracking()
  const isDesktop = useMediaQuery('(min-width:1024px)')

  useEffect(() => {
    const fetchBrands = async () => {
      setLoading(true)
      try {
        setBrands([...brandsData])
        setLoading(() =>false)
      } catch (err) {
        console.log(err);
        notify('Erro ao tentar carregar marcas', 'error')
      }
    }
    fetchBrands()
  }, [])

  function RoutesBrand (id, label) {
    trackClick({
      title: `marca-${label.toLowerCase().replace(/\s/g, '-')}`,
      contentType: "marcas-em-destaque",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    })
    navigate('./brands/' + id)
  }

  return (
    !Loading && (
      <Container>
        {isDesktop ? (
          <DesktopGrid>
            {brands.map((brand, index) => {
              const { id, label, image } = brand
              return (
                <div className="grid-card" key={index + 'grid'}>
                  <Img
                    src={image}
                    alt={label}
                    onClick={() => RoutesBrand(id, label)}
                  />
                  <div>
                    <Span
                      style={{ paddingBottom: 5 }}
                      className="font-wl-500"
                      onClick={() => RoutesBrand(id, label)}
                    >
                      {label}
                    </Span>
                  </div>
                </div>
              )
            })}
          </DesktopGrid>
        ) : (
        <Swiper
          spaceBetween={30}
          slidesPerView={2.5}
          breakpoints={{  568: { slidesPerView: 4 }}}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          onSlideChange={(swiper) => {
            let isEnd = swiper.isEnd;
            if (isEnd) {
              jQuery('.mySwiperBrands').removeClass('margin-right-minus-25');
              jQuery('.mySwiperBrands').addClass('margin-left-minus-25');
            } else {
              jQuery('.mySwiperBrands').removeClass('margin-left-minus-25');
              jQuery('.mySwiperBrands').addClass('margin-right-minus-25');
            }
          }}
          className="mySwiper mySwiperBrands margin-right-minus-25"
        >
          {brands?.map((brand, index) => {
            const { id, label, image } = brand
            return (
              <SwiperSlide key={index}>
                <Img 
                  src={image} 
                  alt={label} 
                  onClick={() => RoutesBrand(id, label)} 
                />
                <div>
                  <Span 
                    style={{paddingBottom:5}} 
                    className="font-wl-500 text-left" 
                    onClick={() => RoutesBrand(id, label)}
                  >
                    {label}
                  </Span>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
        )}
      </Container>
    )
  )
}

FeaturedBrands.propTypes = {
  brandsData: PropTypes.array
}
